/* eslint-disable */
// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type UpdateLanguagesAndWorkPermitMutationVariables = Types.Exact<{
  profileLanguagesUpdateInput: Types.ProfileLanguagesUpdateInput;
  profileWorkEligibilityUpdateInput: Types.ProfileWorkEligibilityUpdateInput;
}>;

export type UpdateLanguagesAndWorkPermitMutation = {
  __typename?: 'Mutation';
  profileLanguagesUpdate?: {
    __typename?: 'ProfileLanguagesUpdateError';
    errors?: {
      __typename?: 'ProfileLanguagesUpdateFieldsError';
      language?: Array<string> | null;
    } | null;
  } | null;
  profileWorkEligibilityUpdate?:
    | { __typename?: 'ProfileWorkEligibility' }
    | {
        __typename?: 'ProfileWorkEligibilityMutationError';
        errors?: any | null;
      }
    | null;
};

export const UpdateLanguagesAndWorkPermitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateLanguagesAndWorkPermit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'profileLanguagesUpdateInput' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ProfileLanguagesUpdateInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'profileWorkEligibilityUpdateInput' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'ProfileWorkEligibilityUpdateInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profileLanguagesUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'profileLanguagesUpdateInput' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'language' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profileWorkEligibilityUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: {
                    kind: 'Name',
                    value: 'profileWorkEligibilityUpdateInput',
                  },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ProfileWorkEligibilityMutationError',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateLanguagesAndWorkPermitMutation,
  UpdateLanguagesAndWorkPermitMutationVariables
>;
